import api from "@/api";
const state = {
  account: localStorage.account || "",
  token: localStorage.token || "",
  // failure_time: localStorage.failure_time || '',
  permissions: [],
  userinfo: localStorage.userinfo ? JSON.parse(localStorage.userinfo) : {},
  menu: localStorage.menu ? JSON.parse(localStorage.menu) : [],
  usertype: 1,
  reflashCount: 0,
  initListItem: {},
};

const getters = {
  isTzzj(state) {
    let flag = false;
    let type = state.userinfo ? state.userinfo.userType : "";
    if (type == 6) flag = true;
    return flag;
  },
  isTzrb(state) {
    let flag = false;
    let type = state.userinfo ? state.userinfo.userType : "";
    if (type == 2) flag = true;
    return flag;
  },
  getInitListItem(state) {
    const userInfo = state.userinfo;
    function isTzrb() {
      let flag = false;
      let type = userInfo ? userInfo.userType : "";
      if (type == 2) flag = true;
      return flag;
    }
    function isTzzj() {
      let flag = false;
      let type = userInfo ? userInfo.userType : "";
      if (type == 6) flag = true;
      return flag;
    }
    function isServeCenter() {
      let flag = false;
      let type = userInfo ? userInfo.userType : "";
      if (type == 9) flag = true;
      return flag;
    }

    let initListItem;
    function isEmptyObj(obj) {
      return JSON.stringify(obj) === "{}";
    }
    // console.log(userInfo && !isEmptyObj(userInfo));

    if (userInfo && !isEmptyObj(userInfo)) {
      if (isTzzj()) {
        initListItem = {
          name: "dashboard",
          path: "/dashboard",
        };
      } else if (isTzrb()) {
        initListItem = {
          path: "/home/index",
          name: "homeIndex",
        };
      } else if (isServeCenter()) {
        initListItem = {
          path: "/home/ScIndex",
          name: "scHomeIndex",
        };
      } else {
        initListItem = {
          path: "/home/tisindex",
          name: "homeTisindex",
        };
      }
    }

    return initListItem;
  },
  isLogin: (state) => {
    let retn = false;
    if (state.token) {
      retn = true;
    }
    return retn;
  },
  menuIdObj: (state) => {
    var obj = {};
    if (state.menu) {
      state.menu.forEach((e) => {
        obj[e.menuId] = e;
      });
    }
    return obj;
  },
  menuTreeArr: (state) => {
    if (state.menu) {
    }
  },
};

const actions = {
  logout({ commit }) {
    commit("removeUserData");
    commit("keepAlive/clean", null, { root: true });
    commit("menu/invalidRoutes", null, { root: true });
  },
  // 获取我的权限
  getPermissions({ state, commit }) {
    return new Promise((resolve) => {
      // 通过 mock 获取权限
      api
        .get("mock/member/permission", {
          params: {
            account: state.account,
          },
        })
        .then((res) => {
          commit("setPermissions", res.data.permissions);
          resolve(res.data.permissions);
        });
    });
  },
};

const mutations = {
  setWeakPassword(state, value) {
    localStorage.setItem("isWeakPassword", value);
  },

  reflashCountAdd(state) {
    state.reflashCount++;
  },
  logout(state) {
    // state.logout
    commit("increment");
  },
  setMenu(state, menu) {
    localStorage.setItem("menu", JSON.stringify(menu));
    state.menu = menu;
  },
  setAccount(state, obj) {
    localStorage.setItem("account", obj.account);
    localStorage.setItem("password", obj.password);
  },
  setToken(state, data) {
    state.token = data;
    localStorage.setItem("token", data);
  },
  setDeadTokenTime() {
    //默认2天
    let deadTokenTime = Number(new Date()) + 2 * 24 * 3600 * 1000;
    localStorage.setItem("deadTokenTime", deadTokenTime);
  },
  setUserData(state, data) {
    localStorage.setItem("account", data.account);
    localStorage.setItem("userinfo", JSON.stringify(data));
    state.account = data.account;
    state.userinfo = data;
  },
  removeUserData(state) {
    localStorage.removeItem("account");
    localStorage.removeItem("token");
    // localStorage.removeItem('failure_time')
    localStorage.removeItem("userinfo");
    localStorage.removeItem("menu");
    localStorage.removeItem("deadTokenTime");
    state.account = "";
    state.token = "";
    // state.failure_time = ''
    state.userinfo = {};
    state.menu = [];
  },
  setPermissions(state, permissions) {
    state.permissions = permissions;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
